import { createFileRoute } from "@tanstack/react-router";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import OrderCreateForm from "./-form";
import { OrderCrumbs } from "./-crumbs";

export const Route = createFileRoute("/_private/_patient-360/order/create")({
  component: OrderCreatePage,
});

function OrderCreatePage() {
  return (
    <div>
      <title>Create Order - Legrande Health Portal</title>
      <OrderCrumbs canEdit />

      {/* Order form */}
      <Card>
        <CardHeader>
          <CardTitle>Create Order</CardTitle>
          <CardDescription>
            Select a doctor and patient to get started.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <OrderCreateForm />
        </CardContent>
      </Card>
    </div>
  );
}
